import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import StyledRegistrationRequest from "./StyledRegistrationRequest";
import { ROUTE_PATH } from "../../constants/route";

const RegistrationRequest = () => {
  return (
    <StyledRegistrationRequest>
      <Box className="registration-wrap">
        <Box className="registration-header">
          <Box className="circleIcon">
            <CheckIcon className="icon-circle" />
          </Box>
          <Box className="header">Registration Request Submitted!</Box>
        </Box>
        <Box className="body-wrap">
          <Typography className="body-text">
            Thank you for signing up! Your registration request is being
            reviewed by our admin team. You will be notified once your account
            is approved.
          </Typography>

          <Typography className="rest-link">
            Have questions? Visit our Help Center
          </Typography>
        </Box>
        <Box className="backLogin">
          <Link to={ROUTE_PATH.DASHBOARD}>Back to Home</Link>
        </Box>
      </Box>
    </StyledRegistrationRequest>
  );
};

export default RegistrationRequest;
